import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';
import { PUBLIC_TRACKED_PAGES } from '@/utils/publicPages';

/** Floating "back to top" pill for long public pages (bottom-left, clear of the chat widget). */
export default function BackToTop() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  const p = pathname.replace(/\/+$/, '') || '/';
  const enabled = PUBLIC_TRACKED_PAGES.has(p) || p.startsWith('/blogs');

  useEffect(() => {
    if (!enabled) return undefined;
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [enabled, pathname]);

  if (!enabled) return null;

  return (
    <button
      type="button"
      aria-label="Back to top"
      className={`ss-top ${visible ? 'is-visible' : ''}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <ArrowUp className="w-5 h-5" strokeWidth={2} />
    </button>
  );
}
